<div class="container p-4">
    <div class="card border-0 shadow-sm mb-3 py-1 px-4">
        <dx-toolbar class="theme-dependent">
            <dxi-item location="before">
                <div class="header-text">{{ checklistId ? 'View Checklist' : 'New Checklist' }}</div>
            </dxi-item>
            @if (!checklistId) {
                <dxi-item location="after" locateInMenu="never">
                    <dx-button
                        text="Cancel"
                        stylingMode="outlined"
                        type="normal"
                        (onClick)="cancel()"
                    >
                    </dx-button>
                </dxi-item>
                <dxi-item location="after" locateInMenu="never">
                    <dx-button
                        text="Submit"
                        icon="save"
                        type="default"
                        stylingMode="contained"
                        [disabled]="isSubmitting"
                        (onClick)="save()"
                    >
                    </dx-button>
                </dxi-item>
            }

            @if (checklistId && checklist.condition == CheckListCondition.Defect) {
                @if (auth.checkPermission(PermissionType.ChecklistRepair, AccessType.Manage)) {
                    <dxi-item location="after" locateInMenu="never">
                        <dx-button
                            text="Repair"
                            type="danger"
                            stylingMode="contained"
                            [disabled]="isSubmitting"
                            (onClick)="repair()"
                        >
                        </dx-button>
                    </dxi-item>
                }
            }
        </dx-toolbar>
    </div>

    <dx-load-panel
        container=".view-wrapper-scroll"
        [visible]="isLoading"
        [showPane]="false"
        [position]="{ of: 'checklist-details' }"
    >
    </dx-load-panel>

    <dx-scroll-view class="view-wrapper-scroll">
        <dx-validation-group #validationGroup>
            @if (!isLoading) {
                <div class="form-container">

                    <!-- Header Info -->
                    <div class="card border-0 shadow-sm pt-0 mb-4">
                        <div class="card-header fs-5 fw-medium">General Information</div>
                        <div class="card-body">
                            @if (checklistId) {
                                <div class="row mb-3">
                                    <div class="col-sm-4">
                                        <user-avatar-email
                                            [email]="checklist.employee?.email"
                                            [name]="checklist.employee?.name"
                                            [avatarUrl]="checklist.employee?.avatarUrl"
                                        ></user-avatar-email>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="d-flex">
                                            <strong class="me-2">Date:</strong>
                                            <span>{{ checklist.created | date:'longDate' }}</span>
                                        </div>
                                        <div class="d-flex">
                                            <strong class="me-2">Shift:</strong>
                                            <span>{{ checklist.shiftCode }} ({{ checklist.shiftType | capitalCase }})</span>
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        @if (checklist.repairDate && checklist.repairedBy) {
                                            <div class="d-flex">
                                                <strong class="me-2">Repair Date:</strong>
                                                <span>{{ checklist.repairDate | date:'longDate' }}</span>
                                            </div>
                                            <div class="d-flex">
                                                <strong class="me-2">Repaired By:</strong>
                                                <span>{{ checklist.repairedBy.name }}</span>
                                            </div>
                                        }
                                    </div>
                                </div>
                            }
                            <div class="row mb-3">
                                @if (checklistId) {
                                    <div class="col-md-6">
                                        <label class="form-label">Condition</label>
                                        <dx-select-box
                                            [value]="checklist.condition"
                                            [items]="conditionOptions"
                                            valueExpr="value"
                                            displayExpr="text"
                                            stylingMode="filled"
                                            placeholder="Condition"
                                            [readOnly]="true"
                                        >
                                        </dx-select-box>
                                    </div>
                                }
                                <div [class]="checklistId ? 'col-md-6' : 'col-md-12'">
                                    <label class="form-label">Asset Type <span class="text-danger">*</span></label>
                                    <dx-select-box
                                        [(value)]="checklist.assetType"
                                        [items]="assetTypeOptions"
                                        valueExpr="value"
                                        displayExpr="text"
                                        stylingMode="filled"
                                        placeholder="Select Type"
                                        [readOnly]="isReadOnly"
                                        (onValueChanged)="onAssetTypeChanged($event)"
                                        [searchEnabled]="true"
                                    >
                                        <dx-validator>
                                            <dxi-validation-rule type="required" message="Type is required"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-select-box>
                                </div>
                            </div>
                            <div class="row g-3">
                                @if (showMachineSelector) {
                                    <div class="col-md-4">
                                        <label class="form-label">Machine ID <span class="text-danger">*</span></label>
                                        <app-asset-select
                                            [(value)]="checklist.machineId"
                                            [assetType]="checklist.assetType"
                                            placeholder="Select Machine"
                                            [readOnly]="isReadOnly"
                                            (onValueChanged)="onMachineChanged($event)"
                                            [isRequired]="true"
                                            requiredMessage="Machine is required"
                                        >
                                        </app-asset-select>
                                    </div>
                                }

                                @if (showTwoWayRadioSelector) {
                                    <div class="col-md-4">
                                        <label class="form-label">2 Way Radio ID
                                            @if (isTwoWayRadioRequired) {
                                                <span class="text-danger">*</span>
                                            }
                                        </label>
                                        <app-asset-select
                                            [(value)]="checklist.twoWayRadioId"
                                            [assetType]="AssetType.TwoWayRadio"
                                            placeholder="Select Radio"
                                            [readOnly]="isReadOnly"
                                            [isRequired]="isTwoWayRadioRequired"
                                            [showClearButton]="true"
                                            requiredMessage="Radio is required"
                                        >
                                        </app-asset-select>
                                    </div>
                                }

                                @if (showRadioShuttleCardSelector) {
                                    <div class="col-md-4">
                                        <label class="form-label">Radio Shuttle Card ID</label>
                                        <app-asset-select
                                            [(value)]="checklist.radioShuttleCardId"
                                            [assetType]="AssetType.RadioShuttleCart"
                                            placeholder="Select Radio Shuttle Card"
                                            [readOnly]="isReadOnly"
                                            [showClearButton]="true"
                                        >
                                        </app-asset-select>
                                    </div>
                                }

                                @if (showEquipmentSelector) {
                                    <div class="col-md-6">
                                        <label class="form-label">Equipment <span class="text-danger">*</span></label>
                                        <app-asset-select
                                            [(value)]="checklist.equipmentId"
                                            [assetType]="checklist.assetType"
                                            placeholder="Select Equipment"
                                            [readOnly]="isReadOnly"
                                            [isRequired]="true"
                                            requiredMessage="Equipment is required"
                                        >
                                        </app-asset-select>
                                    </div>
                                }
                            </div>
                            <div class="row">
                                @if (showMobileLabelPrinterCheck) {
                                    <div class="mt-3 col-sm-4 col-md-3">
                                        <app-machine-attachment-check
                                            label="Mobile Label Printer ID"
                                            [attachmentId]="selectedMachine?.attachments?.mobileLabelPrinterId"
                                            [assetType]="AssetType.MobileLabelPrinter"
                                            [model]="checklist.mobileLabelPrinterCheck!"
                                            [readOnly]="isReadOnly"
                                        ></app-machine-attachment-check>
                                    </div>
                                }

                                @if (showTabletCheck) {
                                    <div class="mt-3 col-sm-4 col-md-3">
                                        <app-machine-attachment-check
                                            label="Tablet Computer ID"
                                            [attachmentId]="selectedMachine?.attachments?.tabletComputerId"
                                            [assetType]="AssetType.TabletComputers"
                                            [model]="checklist.tabletComputerCheck!"
                                            [readOnly]="isReadOnly"
                                        ></app-machine-attachment-check>
                                    </div>
                                }

                                @if (showRfGunCheck) {
                                    <div class="mt-3 col-sm-4 col-md-3">
                                        <app-machine-attachment-check
                                            label="RF Scan Gun ID"
                                            [attachmentId]="selectedMachine?.attachments?.rfScanGunId"
                                            [assetType]="AssetType.RfScanGuns"
                                            [model]="checklist.rfScanGunCheck!"
                                            [readOnly]="isReadOnly"
                                        ></app-machine-attachment-check>
                                    </div>
                                }

                                @if (showClampLayerCheck) {
                                    <div class="mt-3 col-sm-4 col-md-3">
                                        <app-machine-attachment-check
                                            label="Clamp Layer Attachment ID"
                                            [attachmentId]="selectedMachine?.attachments?.clampLayerAttachId"
                                            [assetType]="AssetType.ClampLayerAttach"
                                            [model]="checklist.clampLayerAttachCheck!"
                                            [readOnly]="isReadOnly"
                                        ></app-machine-attachment-check>
                                    </div>
                                }

                                @if (showSlipSheetCheck) {
                                    <div class="mt-3 col-sm-4 col-md-3">
                                        <app-machine-attachment-check
                                            label="Slip Sheet Attachment ID"
                                            [attachmentId]="selectedMachine?.attachments?.slipSheetAttachId"
                                            [assetType]="AssetType.SlipSheetAttach"
                                            [model]="checklist.slipSheetAttachCheck!"
                                            [readOnly]="isReadOnly"
                                        ></app-machine-attachment-check>
                                    </div>
                                }

                                @if (showBattery) {
                                    <div class="mt-3 col-sm-4 col-md-3">
                                        <app-machine-attachment-check
                                            label="MHE Battery ID"
                                            [attachmentId]="selectedMachine?.attachments?.mheBatteryId"
                                            [assetType]="AssetType.MheBatteries"
                                            [model]="checklist.mhBatteryCheck!"
                                            [readOnly]="isReadOnly"
                                        ></app-machine-attachment-check>
                                    </div>
                                }
                            </div>
                            @if(checklist.radioShuttleCardId){
                                <div class="row">
                                    <div class="mt-3 col-sm-4 col-md-3">
                                        <label class="form-label">Radio Shuttle Remote ID <span class="text-danger">*</span></label>
                                        <app-asset-select
                                            [(value)]="checklist.radioShuttleRemoteId"
                                            [assetType]="AssetType.RadioShuttleRemote"
                                            placeholder="Select Radio Shuttle Remote"
                                            [readOnly]="isReadOnly"
                                            [isRequired]="true"
                                            requiredMessage="Radio Shuttle Remote is required"
                                        >
                                        </app-asset-select>
                                    </div>
                                    <div class="mt-3 col-sm-4 col-md-3">
                                        <label class="form-label">Radio Shuttle Battery ID <span class="text-danger">*</span></label>
                                        <app-asset-select
                                            [(value)]="checklist.radioShuttleBatteryId"
                                            [assetType]="AssetType.RadioShuttleBatteries"
                                            placeholder="Select Radio Shuttle Battery"
                                            [readOnly]="isReadOnly"
                                            [isRequired]="true"
                                            requiredMessage="Radio Shuttle Battery is required"
                                        >
                                        </app-asset-select>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>

                    <app-checklist-questions
                        [assetId]="selectedAssetId"
                        [initialAnswers]="checklist.answers!"
                        [readOnly]="isReadOnly"
                        [includeRadioShuttleQuestions]="checklist.radioShuttleCardId != null"
                        [includeTwoWayRadioQuestions]="checklist.twoWayRadioId != null"
                    >
                    </app-checklist-questions>
                </div>

                <div class="mt-4">
                    <app-notes
                        [entityId]="checklistId"
                        [noteType]="NoteType.Checklist"
                        [canCreate]="true"
                        [required]="hasDefects"
                    ></app-notes>
                </div>
            }
        </dx-validation-group>
    </dx-scroll-view>
</div>
